// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2QCF_","search":"Settings_search__3tkOP","filter":"Settings_filter__28Q5E"};